import type { Sendable } from '@/interfaces/Sendable'
import { ProjectsService } from '@/api/client'
import { type Error } from '@/types/error'
import { DateTime } from 'luxon'

type TProjectCompletionMeta = {
  transmitted: boolean
  transmitted_at: string
  error_log: Error[]
}

export type TDehydratedProjectCompletion = {
  meta: TProjectCompletionMeta
  completed_date: string
  project_id: number
  type: 'project_completion'
}

export class ProjectCompletion implements Sendable {
  readonly type = 'project_completion'
  meta: TProjectCompletionMeta
  project_id: number
  completed_date: string | null

  constructor(
    project_id: number,
    completed_date?: string | null,
    meta?: TProjectCompletionMeta,
  ) {
    if (meta) {
      this.meta = meta
    } else {
      this.meta = {
        transmitted: false,
        transmitted_at: DateTime.now().toISO(),
        error_log: [],
      }
    }
    if (completed_date !== undefined) {
      this.completed_date = completed_date
    } else {
      this.completed_date = DateTime.now().toISO()
    }
    this.project_id = project_id
  }

  send(): Promise<{
    error: false | Error
  }> {
    return new Promise(async (resolve, reject) => {
      const response = await ProjectsService.completeProject(this.project_id, {
        completed_date: this.completed_date,
      })
      if (response.error) {
        reject(response.error)
        return
      }
      resolve({ error: false })
    })
  }
  isReady() {
    return true
  }
  cleanup() {
    return true
  }

  static fromJSON(dehydratedProjectCompletion: TDehydratedProjectCompletion) {
    return new ProjectCompletion(
      dehydratedProjectCompletion.project_id,
      dehydratedProjectCompletion.completed_date,
      dehydratedProjectCompletion.meta,
    )
  }
  toJSON(): TDehydratedProjectCompletion {
    return {
      type: this.type,
      meta: this.meta,
      completed_date: this.completed_date ?? '',
      project_id: this.project_id,
    }
  }
}
